import { COOKIE_DURATION, cookieOpts } from '@/utils/cookieOptions'

export default {
  data() {
    return {
      togglingFavorite: false,
    }
  },
  methods: {
    toggleFavorite(product) {
      if (this.togglingFavorite) return

      if (this.isFavorite(product)) {
        const favorite = this.$store.state.favorites.find(
          element => element.favoritable_product.id === product.id
        )
        if (favorite) {
          this.togglingFavorite = true
          this.$favoriteService
            .delete(favorite.id)
            .then(() => {
              this.$store.dispatch('setFavorites')
            })
            .catch(error => {
              this.$swalErrorMessage(error)
            })
            .finally(() => {
              this.togglingFavorite = false
            })
        }
      } else {
        this.togglingFavorite = true
        this.$favoriteService
          .create({
            favoritable_type: 'product',
            favoritable_id: product.id,
          })
          .then(data => {
            this.$nuxtCookies.set('favorite_token', data.token, cookieOpts(COOKIE_DURATION.MONTH, { secure: true }))
            this.$store.dispatch('setFavorites')
          })
          .catch(error => {
            this.$swalErrorMessage(error)
          })
          .finally(() => {
            this.togglingFavorite = false
          })
      }
    },

    isFavorite(product) {
      if (Array.isArray(this.$store.state.favorites)) {
        const favorite = this.$store.state.favorites.find(element => {
          return element.favoritable_product.id === product.id
        })
        return favorite ? true : false
      }
      return false
    },
  },
}
